"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReleasesDashboardSearchResponse = void 0;
const common_1 = require("../../../common");
const releases_dashboard_data_response_1 = require("./releases-dashboard-data.response");
class ReleasesDashboardSearchResponse extends common_1.PaginatedResponse {
}
exports.ReleasesDashboardSearchResponse = ReleasesDashboardSearchResponse;
//# sourceMappingURL=releases-dashboard-search.response.js.map